import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import { Autocomplete, TextField } from "@mui/material";
import "./index.css";

const DropdownAndAutocompleteTransport = ({ data, onResultClick }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [filteredData, setFilteredData] = useState(data);
  const { t } = useTranslation();

  const options = [
    t("INVOICE_DATE"),
    t("INVOICE_NO"),
    t("SUPPLIER"),
    t("CLIENT"),
  ];

  const handleOptionChange = (event, value) => {
    setSelectedOption(value);
    if (value === "") {
      setFilteredData(data);
    } else {
      const filteredItems = data.filter((item) => {
        switch (value) {
          case `${t("INVOICE_DATE")}`:
            return item.invoice_date !== null;
          case `${t("INVOICE_NO")}`:
            return item.invoice_number !== null;
          case `${t("SUPPLIER")}`:
            return (
              item.supplier !== null &&
              item.supplier !== "" &&
              item.supplier !== undefined
            );
          case `${t("CLIENT")}`:
            return (
              item.client !== null &&
              item.client !== "" &&
              item.client !== undefined
            );
          default:
            return item.invoice_date !== null;
        }
      });
      setFilteredData(filteredItems);
    }
  };

  return (
    <div className="sort-quick-navigate">
      <p
        style={{
          marginBottom: "0",
          padding: "12px",
          marginRight: "20px",
          color: "#FBFBFB",
          fontSize: "14px",
        }}
      >
        {t("SEARCH_AFTER")}
      </p>
      <div>
        <Autocomplete
          placeholder="Choose"
          options={options}
          value={selectedOption}
          onChange={handleOptionChange}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t("CHOOSE")}
              InputLabelProps={{ style: { color: "white", fontSize: "12px" } }}
              InputProps={{
                ...params.InputProps,
                className: "sort-input",
              }}
            />
          )}
          classes={{
            option: {
              "&.Mui-selected": {
                color: "white",
              },
            },
            paper: "sort-custom-dropdown",
          }}
          sx={{
            width: "180px",
          }}
        />
      </div>
      <div style={{ marginLeft: "20px" }}>
        <Autocomplete
          options={filteredData}
          getOptionLabel={(option) => {
            switch (selectedOption) {
              case `${t("INVOICE_DATE")}`:
                return option.invoice_date;
              case `${t("INVOICE_NO")}`:
                return option.invoice_number;
              case `${t("SUPPLIER")}`:
                return option.supplier;
              case `${t("CLIENT")}`:
                return option.client;
              default:
                return option.nickname;
            }
          }}
          sx={{
            width: "200px",
            "& .MuiAutocomplete-option.Mui-selected": {
              color: "white",
            },
          }}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          renderInput={(params) => (
            <TextField
              placeholder={t("START_TYPING")}
              {...params}
              InputProps={{
                ...params.InputProps,
                style: { color: "white" },
                className: "sort-input",
              }}
            />
          )}
          classes={{
            option: {
              "&.Mui-selected": {
                color: "white",
              },
            },
            paper: "sort-custom-dropdown",
          }}
          onChange={(event, option) => {
            if (!selectedOption) {
              return;
            }

            let identifier = option && option?.id;

            onResultClick(identifier);
          }}
          onClick={(option) => onResultClick(option.id)}
        />
      </div>
    </div>
  );
};

export default DropdownAndAutocompleteTransport;
